import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidNumberWriting } from '../../../../mechanics/rid-number-writing/rid-number-writing';

@Component({
  selector: 'app-splitting-page',
  imports: [RidNumberWriting],
  templateUrl: './number-writing-page.html',
})
export class NumberWritingPage {
  protected readonly $router = inject(Router);
}
